import { render, staticRenderFns } from "./dropdown-arrow-down.vue?vue&type=template&id=15842d0f&"
import script from "./dropdown-arrow-down.vue?vue&type=script&lang=js&"
export * from "./dropdown-arrow-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports